import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import {  UtilsService } from 'src/app/services';
import {NotificationStatus} from '../../../../services/notification/notification.service';
import {ApiKey} from '../../../../models/apiKey';

@Component({
  selector: 'app-copy-token-dialog',
  templateUrl: './copy-token-dialog.component.html',
  styleUrls: ['./copy-token-dialog.component.scss']
})
export class CopyTokenDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: ApiKey,
              public utilsService: UtilsService) {
  }

  copyKey() {
    this.utilsService.copy(this.data.jwt, {announcementMessage: 'Your Key has been copied to the clipboard.', status: NotificationStatus.SUCCESS});
  }
}
